import { FileDown } from "lucide-react";
import { FadeUp } from "../Reveal";

export const Plaquette = () => (
  <section data-testid="plaquette-section" className="bg-ivoire py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <FadeUp>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-sagelight border border-sage/20 px-8 py-12 sm:px-14 lg:px-20 lg:py-16">
          <div
            className="absolute -right-16 -top-24 w-64 h-64 rounded-t-full bg-white/50 rotate-90"
            aria-hidden="true"
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <p className="text-xs uppercase tracking-[0.28em] font-semibold text-teal mb-4">
                Documentation
              </p>
              <h2 className="font-display font-medium text-petrol text-3xl sm:text-4xl leading-tight tracking-tight mb-4">
                Plaquette commerciale EQUORIS
              </h2>
              <p className="text-base text-mute leading-relaxed max-w-xl">
                Découvrez EQUORIS, son approche et ses univers de matériaux dans notre
                plaquette commerciale, à consulter en ligne ou à télécharger.
              </p>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <a
                href="/plaquette-commerciale-equoris.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="plaquette-download-btn"
                className="group inline-flex items-center gap-3 rounded-full bg-petrol text-ivoire text-sm font-semibold px-7 py-4 transition-all duration-300 hover:bg-teal hover:-translate-y-0.5"
              >
                <FileDown className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-0.5" />
                Télécharger notre plaquette commerciale
              </a>
            </div>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
